/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';

import { useResponsive } from '../hooks/useResponsive';
import { LinearProgress } from '@mui/material';

export const IndicatorValue = ({
  label,
  value,
  color,
  explain,
  status = 'idle',
}) => {
  const { isDesktop } = useResponsive();

  const [openTooltip, setOpenTooltip] = useState(false);

  const handleOpen = () => {
    setOpenTooltip(true);
  };

  const handleClose = () => {
    setOpenTooltip(false);
  };

  const style = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      paddingX: '.5em',
      alignItems: 'center',
      width: '100%',
      minWidth: 250,
      justifyContent: 'space-between',
    },
    labelContainer: {
      display: 'flex',
      gap: 1,
      alignItems: 'center',
    },
    valueContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItem: 'center',
    },
  };

  return (
    <Box sx={style.container}>
      <Box sx={style.labelContainer}>
        <Typography sx={{ fontSize: '1em', textAlign: 'center' }}>
          {label}
        </Typography>
        <Tooltip
          open={openTooltip}
          arrow
          title={
            <Typography fontSize={isDesktop ? null : '1.4em'}>
              {explain}
            </Typography>
          }
          placement='bottom'
          onClose={handleClose}
        >
          <IconButton
            size='small'
            onMouseEnter={handleOpen}
            onMouseLeave={handleClose}
          >
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={style.valueContainer}>
        {status === 'loading' ? (
          <Box
            style={{
              display: 'flex',
              paddingTop: '1em',
              width: '120px',
              height: '12px',
            }}
            color={color}
          >
            <LinearProgress
              style={{
                display: 'flex',
                width: '100%',
              }}
              color='inherit'
            />
          </Box>
        ) : (
          <Typography sx={{ fontSize: '1.2em', fontWeight: 700, color: color }}>
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
